export const heartDisease = {
    symptoms: {
        1: "Dizziness, lightheadedness and fainting.",
        2: "Feeling short of breath during activity or at rest.",
        3: "Feeling short of breath at night when trying to sleep or waking up short of breath.",
        4: "Irregular heartbeats that feel rapid, pounding or fluttering.",
        5: "Swollen legs, ankles or feet."
    },

    precautions: {
        1: "Eat a healthy, balanced diet.",
        2: "Reduce your alcohol consumption.",
        3: "Keep your blood pressure under control.",
        4: "Keep your diabetes under control.",
        5: "Swollen legs, ankles or feet."
    },

    description: "Heart disease refers to a range of conditions that affect the heart, including coronary artery disease, heart rhythm problems (arrhythmias), heart defects present at birth (congenital heart defects), and others. It's also often called cardiovascular disease."
};

export const diabetes = {
    symptoms: {
        1: "Genital itching or thrush.",
        2: "Cuts and wounds take longer to heal.",
        3: "Blurred eyesight.",
        4: "Toilet - going for a wee a lot, especially at night.",
        5: "Thirsty - being really thirsty."
    },

    precautions: {
        1: "Keep your blood pressure and cholesterol under control.",
        2: "Schedule regular physicals and eye exams.",
        3: "If you drink alcohol, do so responsibly.",
        4: "Consider a daily aspirin.",
        5: "Schedule regular physicals and eye exams."
    },

    description: "Diabetes is a disease that occurs when your blood glucose, also called blood sugar, is too high. Blood glucose is your main source of energy and comes from the food you eat. Insulin, a hormone made by the pancreas, helps glucose from food get into your cells to be used or energy."
};

export const cardio = {
    symptoms: {
        1: "Dizziness, lightheadedness and fainting.",
        2: "Feeling short of breath during activity or at rest.",
        3: "Feeling short of breath at night when trying to sleep or waking up short of breath.",
        4: "Irregular heartbeats that feel rapid, pounding or fluttering.",
        5: "Swollen legs, ankles or feet."
    },

    precautions: {
        1: "Eat a healthy, balanced diet.",
        2: "Reduce your alcohol consumption.",
        3: "Keep your blood pressure under control.",
        4: "Keep your diabetes under control.",
        5: "Swollen legs, ankles or feet."
    },
    
    description: "Cardiovascular disease (CVD) is a broad term that encompasses a range of conditions affecting the heart and blood vessels. It is one of the leading causes of death worldwide. Cardiovascular diseases include various conditions such as coronary artery disease (CAD), heart failure, stroke, peripheral artery disease (PAD), and others."
};

export const blood_test = {
    "Anemia": {
        symptoms: {
            1: "Blue color to the whites of the eyes.",
            2: "Desire to eat ice or other non-food things (pica syndrome).",
            3: "Lightheadedness when you stand up.",
            4: "Shortness of breath with mild activity or even at rest.",
            5: "Sore or inflamed tongue."
        },
        
        precautions: {
            1: "Eating foods that are rich in iron, folate, vitamin B12, vitamin A, and other nutrients.",
            2: "Beware of Calcium-Containing Foods.",
            3: "Say No to Gluten.",
            4: "Avoid Tannins.",
            5: "Avoid Phytates."
        },
        
        description: "Anemia is a medical condition characterized by a deficiency in the number of red blood cells (RBCs) or the amount of hemoglobin (the oxygen-carrying protein within RBCs) in the blood. This deficiency leads to a reduced ability of the blood to carry oxygen to the body's tissues, which can result in various symptoms and complications."
    },

    "Talasse": {
        symptoms: {
            1: "Fatigue.",
            2: "Weakness.",
            3: "Pale or yellowish skin.",
            4: "Facial bone deformities.",
            5: "Abdominal swelling."
        },
    
        precautions: {
            1: "Adopting a healthy lifestyle can help individuals with thalassemia manage their condition more effectively.",
            2: "Certain antibiotics and nonsteroidal anti-inflammatory drugs (NSAIDs), can worsen anemia or increase the risk of complications in individuals with thalassemia.",
            3: "It's important to stay up-to-date on vaccinations recommended by healthcare providers.",
            4: "Eating a nutritious diet rich in iron and other essential nutrients, staying physically active (as tolerated), avoiding smoking and excessive alcohol consumption, and getting adequate rest and sleep.",
            5: "Genetic counseling can provide information about the risk of passing thalassemia to offspring and options for prenatal testing and family planning."
        },
    
        description: "Thalassemia is a group of inherited blood disorders characterized by abnormal production of hemoglobin, the protein in red blood cells (RBCs) that carries oxygen throughout the body. Hemoglobin is made up of two types of protein chains: alpha and beta. Thalassemia results from mutations in the genes responsible for producing these protein chains, leading to reduced production or malfunctioning of one or more of the chains."
    }
    ,
    "Thromboc": {
        symptoms: {
            1: "Swelling of the leg or along a vein in the leg.",
            2: "Pain or tenderness in the leg, which you may feel only when standing or walking.",
            3: "Increased warmth in the area of the leg that's swollen or painful.",
            4: "Red or discolored skin on the leg.",
            5: "Pain with deep breathing."
        },
    
        precautions: {
            1: "Wear special stockings (called compression stockings) if your doctor prescribes them.",
            2: "Avoid refined, processed foods like white bread, white rice, crackers, french fries, sugary cereals, pastries, pre-packaged food, and fast food.",
            3: "Change your position often, especially during a long trip.",
            4: "Should consume fruits, poultry, vegetables, fish, nuts beans and many more.",
            5: "Drinking one to four cups of coffee a day can raise your chances of thromoc by 11%, and if you drink more than five cups a day, you can lower your odds by 25%."
        },
    
        description: "Thrombosis is a medical condition characterized by the formation of a blood clot (thrombus) within a blood vessel, obstructing blood flow. This can occur in both arteries and veins and can lead to various complications depending on the location and size of the clot."
    },
    "Healthy": {
        description: "No Symptoms" ,
        precautions: {
            1: "Keep your blood pressure and cholesterol under control.",
            2: "Schedule regular physicals and eye exams.",
            3: "If you drink alcohol, do so responsibly.",
            4: "Consider a daily aspirin.",
            5: "Schedule regular physicals and eye exams."
        },
    },
    "Diabetes": {
        symptoms: {
            1: "Genital itching or thrush.",
            2: "Cuts and wounds take longer to heal.",
            3: "Blurred eyesight.",
            4: "Toilet - going for a wee a lot, especially at night.",
            5: "Thirsty - being really thirsty."
        },
    
        precautions: {
            1: "Keep your blood pressure and cholesterol under control.",
            2: "Schedule regular physicals and eye exams.",
            3: "If you drink alcohol, do so responsibly.",
            4: "Consider a daily aspirin.",
            5: "Schedule regular physicals and eye exams."
        },
    
        description: "Diabetes is a disease that occurs when your blood glucose, also called blood sugar, is too high. Blood glucose is your main source of energy and comes from the food you eat. Insulin, a hormone made by the pancreas, helps glucose from food get into your cells to be used or energy."
    }
};

export const kidneyStone = {
    symptoms : {
        1: "Severe pain on either side of your lower back.",
        2: "More vague pain or stomach ache that doesn't go away.",
        3: "Blood in the urine.",
        4: "Urine that smells bad or looks cloudy.",
        5: "Nausea or vomiting."
    },
    
    precautions : {
        1: "Eat enough dietary calcium.",
        2: "Limit foods with high oxalate content.",
        3: "Eat enough dietary calcium.",
        4: "Eat a moderate amount of protein.",
        5: "Avoid high doses of vitamin C supplements."
    },
    
    description : "Kidney stones, also known as renal calculi, are hard deposits that form in the kidneys when substances in the urine become highly concentrated. These substances can include calcium, oxalate, uric acid, and other minerals and salts. Kidney stones vary in size, from tiny crystals to stones that are several centimeters in diameter, and they can cause severe pain and other complications."
};

export const liver = {
    symptoms:{
        1: "Yellowing of the skin and the whites of the eyes, called jaundice. Yellowing of the skin might be harder to see on Black or brown skin.",
        2: "Belly pain and swelling.",
        3: "Constant tiredness.",
        4: "Dark urine.",
        5: "Nausea or vomiting."
    },  
    precautions:{
        1: "Maintaining a healthy weight.",
        2: "Avoiding alcohol, which makes your liver work harder to do its job.",
        3: "Eating a healthy diet.",
        4: "Exercising regularly.",
        5: "Only taking medications that you need and carefully following dosing recommendations"
    }, 
    description : "Liver disease encompasses a range of conditions affecting the liver's structure or function, often leading to symptoms like fatigue, jaundice, and abdominal pain. Causes include viral infections, excessive alcohol consumption, autoimmune disorders, and metabolic abnormalities. "
};


export const ct_scan = {
    symptoms : {
        1: "A lump or thickening in the breast or underarm area is a common sign of chest cancer.",
        2: "Chest pain that worsens with deep breathing, coughing, or laughing.",
        3: "Coughing up blood or rust-colored sputum.",
        4: "Recurrent respiratory infections, such as bronchitis or pneumonia.",
        5: "Shortness of breath or wheezing."
    },
    
    precautions : {
        1: "Smoking is the leading cause of lung cancer. If you smoke, quit smoking as soon as possible.",
        2: "Reduce exposure to environmental carcinogens such as radon, asbestos, arsenic, and certain industrial chemicals.",
        3: "Maintain a healthy lifestyle by eating a balanced diet rich in fruits and vegetables, exercising regularly, and maintaining a healthy weight.",
        4: " Excessive alcohol consumption has been linked to an increased risk of lung cancer.",
        5: "Regular Health Check-ups for early detection of the disease."
    },
    
    description :"Lung cancer originates in the cells of the lungs and is typically categorized into two main types: non-small cell lung cancer (NSCLC) and small cell lung cancer (SCLC). NSCLC accounts for the majority of lung cancer cases and includes adenocarcinoma, squamous cell carcinoma, and large cell carcinoma. SCLC is less common but tends to grow and spread more rapidly."
};

export const diabetic_retinopathy = {
    symptoms : {
        1: "Blurriness or difficulty focusing, especially affecting central vision.",
        2: "Dark spots or lines that float in the field of vision, often caused by bleeding in the eye.",
        3: "Difficulty distinguishing between colors or perceiving colors less vividly.",
        4: "Progressive loss of vision, especially if diabetic retinopathy is left untreated.",
        5: "Reduced ability to see in low light conditions."
    },
    
    precautions :{
        1: "Maintaining stable blood sugar levels is crucial in preventing and managing diabetic retinopathy.",
        2: "Adopt a healthy lifestyle that includes regular exercise, a balanced diet rich in fruits, vegetables, whole grains, and lean proteins.",
        3: "Protect your eyes from injury and harmful ultraviolet (UV) rays by wearing sunglasses and safety goggles when necessary.",
        4: "Exercise can help improve blood circulation, manage blood sugar levels, and reduce the risk of complications associated with diabetes, including diabetic retinopathy.",
        5: "Be aware of the signs and symptoms of diabetic retinopathy, such as blurred or distorted vision, floaters, dark spots, or difficulty seeing at night. "
    },
    
    description :"Diabetic retinopathy is a complication of diabetes that affects the eyes, particularly the retina, which is the light-sensitive tissue at the back of the eye. It occurs when high levels of blood sugar damage the blood vessels in the retina."
};


export const skin_disease = {
    symptoms : {
        1: "Rashes are a common symptom of many skin conditions and can appear as red, inflamed areas of the skin with or without raised bumps, blisters, or scaling.",
        2: "Itching is a prevalent symptom of skin diseases and can range from mild to severe, causing discomfort and irritation.",
        3: "Skin diseases like eczema and psoriasis can cause dry, flaky patches of skin, often accompanied by itching and inflammation.",
        4: "Conditions such as psoriasis or seborrheic dermatitis can cause thick, scaly patches of skin or crusts to develop.",
        5: "Skin diseases can cause changes in pigmentation, leading to areas of hyperpigmentation (darkening) or hypopigmentation (lightening) of the skin."
    },
    
    precautions : {
        1: "Practice good hygiene by washing your skin regularly with mild soap and water. Be gentle when cleansing to avoid irritating the skin.",
        2: "Identify and avoid triggers or irritants that can exacerbate skin conditions, such as harsh soaps, detergents, perfumes, and certain fabrics.",
        3: "Eat a balanced diet rich in fruits, vegetables, and whole grains to support overall skin health.",
        4: "Refrain from scratching or picking at skin lesions, as this can lead to infections, scarring, and worsening of the condition.",
        5: "Consult a dermatologist or healthcare provider if you notice any changes in your skin, such as new or worsening symptoms, persistent rashes or lesions, or signs of infection. "
    },
    
    description : "Skin diseases encompass a wide range of conditions that affect the skin's structure, function, or appearance. These conditions can be temporary or chronic and may result from various factors such as genetics, immune system dysfunction, infections, allergies, environmental factors, or underlying medical conditions."
};

export const cataract = {
    symptoms:{
    1:"blurred or cloudy vision",
    2:"increased difficulty seeing at night",
    3:"frequent changes in eyeglass or contact lens prescription.",
    4:"double vision in one eye"},
precautions:{
1:"maintaining a healthy diet rich in antioxidants",
2:"controlling diabetes and other medical conditions, and getting regular eye exams.",
3:"wearing sunglasses with UV protection"
    },
    description: "A cataract is a common eye condition that causes clouding of the eye's natural lens, leading to blurred vision."
};

